module.exports = __webpack_public_path__ + "js/components/images/flag-malaysia-f4c8adad63dc13c676fc5bada6c17f85.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/images/flag-malaysia.png
// module id = 824
// module chunks = 31